import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { OrganizationService } from '../organization.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'edit-organization',
  providers: [
    OrganizationService, TranslateService
  ],
  template: require('./organization-edit.html')
})
export default class EditOrganization {
  @Input('isVisible') isVisible: boolean;
  @Input('orgData') orgData;
  @Output('onClose') selfClose = new EventEmitter();

  private subscription: Subscription;
  private active: boolean = true;
  private formData: any;
  private isOperationInProgress: boolean = false;

  constructor(public organizationService: OrganizationService,
              private translateService: TranslateService) {
    translateService.use(GlobalVariables.LOCALE);
  }
  ngOnInit() {
    this.formData = this.orgData;
    this.reset();
  }
  ngOnChanges(changes) {
    this.formData = this.orgData;
    this.reset();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  cancel() {
    this.closeSelf();
  }
  // Workaround until form has a reset method
  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
  }
  onSubmitForm(f: NgForm): void {
    if ( f.valid ) {
        this.editOrg(f.value);
    }
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: 'close'
      });
    }
  }

  private preparePayloadForRest(formData) {
    let returnObj = {
      'objectId': formData.organization,
      'fullName': formData.fullName,
      'description': formData.description
    };
    return returnObj;
  }

  private editOrg(obj) {
    if (this.orgData && this.orgData.organization) {
      this.isOperationInProgress = true;
      this.subscription = this.organizationService.updateOrg(this.preparePayloadForRest(obj), this.orgData.organization)
        .subscribe (
          res => {
            this.isOperationInProgress = false;
            this.closeSelf();
          },
          error => {
            this.isOperationInProgress = false;
            this.logError(error, 'edit Org');
          },
          () => this.logOperationCompleted('edit Org')
        );
    } else {
      this.logError('Org Id could not be found');
    }
  }
  private logError(error, origin: String = '') {
    console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }
  private logOperationCompleted(msg: string) {
    this.isOperationInProgress = false;
  }

};



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/organization/edit/organization-edit.component.ts